import { memo } from 'react';
import { useStateSelector } from 'hooks';

import UserSettingsPickerView from 'components/controls/user-settings-picker';

const UserSettingsPicker = () => {
  const { user, privacyPolicy } = useStateSelector((state) => ({
    user: state.app.userSettings,
    privacyPolicy: state.app.privacyPolicy,
  }));

  return <UserSettingsPickerView privacyPolicy={privacyPolicy} user={user} />;
};

export default memo(UserSettingsPicker);
